import { useMutation } from '@apollo/client';
import { getListingTypes } from '@seek/sbiz-taxonomies';
import { Checkbox, Heading, Stack } from 'braid-design-system';
import { useEffect, useState } from 'react';

import ADD_PREFERENCES_BUSINESS_TYPE from '../../queries/addPreferencesBusinessType';
import REMOVE_PREFERENCES_BUSINESS_TYPE from '../../queries/removePreferencesBusinessType';

interface Props {
  businessTypes: any[];
}

const BusinessType = ({ businessTypes }: Props) => {
  const [addPreferencesBusinessType] = useMutation(
    ADD_PREFERENCES_BUSINESS_TYPE,
  );
  const [removePreferencesBusinessType] = useMutation(
    REMOVE_PREFERENCES_BUSINESS_TYPE,
  );
  const [business, setBusiness] = useState(false);
  const [franchiseNew, setFranchiseNew] = useState(false);
  const [franchiseResale, setFranchiseResale] = useState(false);
  const [licenceDistribution, setLicenceDistribution] = useState(false);
  const listingTypes = getListingTypes().sort((a, b) =>
    a.title < b.title ? -1 : 1,
  );
  interface CheckboxState {
    value: boolean;
    setValue: any;
  }
  useEffect(() => {
    setBusiness(businessTypes.includes('Business'));
    setFranchiseNew(businessTypes.includes('Franchise New'));
    setFranchiseResale(businessTypes.includes('Franchise Resale'));
    setLicenceDistribution(businessTypes.includes('Licence/Distribution'));
  }, [businessTypes]);
  const toggleChoice = (key: string) => {
    const currentValue = businessTypeValues[key];
    if (currentValue.value) {
      // current value is selected - they have unchecked the box
      // need to remove the value
      removePreferencesBusinessType({
        variables: {
          input: { id: key },
        },
      });
    } else {
      addPreferencesBusinessType({
        variables: {
          input: { id: key },
        },
      });
    }
    currentValue.setValue(!currentValue.value);
  };
  const businessTypeValues: Record<string, CheckboxState> = {
    '3': {
      value: business,
      setValue: setBusiness,
    },
    '1': {
      value: franchiseNew,
      setValue: setFranchiseNew,
    },
    '2': {
      value: franchiseResale,
      setValue: setFranchiseResale,
    },
    '4': {
      value: licenceDistribution,
      setValue: setLicenceDistribution,
    },
  };
  return (
    <Stack space="medium">
      <Heading level="4">Business Types</Heading>

      <Stack space="small">
        {listingTypes.map((t, k) => {
          const vals = businessTypeValues[t.id];
          return (
            <Checkbox
              id={t.id}
              onChange={() => toggleChoice(t.id)}
              label={t.title}
              checked={vals.value}
              key={k}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};

export default BusinessType;
